import { Component, OnInit, ViewChild, NgZone, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { globals } from '../../../../globals';
import { ISubscription } from 'rxjs/Subscription';
import { ManuscriptsService } from '../../../services/manuscripts.service';
import { AppContentsService } from '../../../services/app-contents.service';
import { ManuscriptList } from '../../../models/manuscript';
import { MssListFilters } from '../../../models/mss-list-filters';
// import { GetMsTitlePipe } from '../../../pipes/get-ms-title.pipe';
import { DateRange, DateCalendar } from '../../../models/date-range';
import { GoogleChartInterface } from 'ng2-google-charts/google-charts-interfaces';
import { ChartSelectEvent } from 'ng2-google-charts';

@Component({
  selector: 'app-home-timechart',
  templateUrl: './home-timechart.component.html',
  styleUrls: ['./home-timechart.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class HomeTimechartComponent implements OnInit, OnDestroy {
    private mssList: ManuscriptList;
    private mssListFilters: MssListFilters;
    private subscriptions: Array<ISubscription> = [];
    public chartData: GoogleChartInterface;
    title: SafeHtml;
    subtitle: SafeHtml;

    constructor(
        private sanitizer: DomSanitizer,
        private router: Router,
        private manuscriptsService: ManuscriptsService,
        // private getMsTitlePipe: GetMsTitlePipe,
        private appContentsService: AppContentsService
        // private zone: NgZone
    ) {
    }

    ngOnInit() {
        this.title = globals.html_small_loading_gif;
        this.subtitle = globals.html_small_loading_gif;

        /* Static contents */
        this.subscriptions.push(
            this.appContentsService.getPageContents('home')
                .subscribe(
                    page => {
                        if (page && page.name === 'home') {
                            const contents = page.contents.find(c => c.name === 'timechart');
                            if (contents) {
                                this.title = this.sanitizer.bypassSecurityTrustHtml(contents.title);
                                this.subtitle = this.sanitizer.bypassSecurityTrustHtml(contents.text);
                            }
                        }
                    },
                    err => console.error(err)
                )
        );

        /* Reset filters without reloading manuscript list */
        this.manuscriptsService.resetFilters(false);

        /* Load manuscript list */
        this.subscriptions.push(
            this.manuscriptsService.getManuscripts(false)
                .subscribe(response => {
                    this.mssList = response;
                    this.initChart();
                },
                    err => console.error(err)
                )
        );

        /* Load manuscript filters */
        this.subscriptions.push(
            this.manuscriptsService.getMssListFilters()
                .subscribe(response => {
                    this.mssListFilters = response;
                },
                    err => console.error(err)
                )
        );
    }

    initChart(): void {
        if (this.mssList && this.mssList.length > 0) {
            /* Counters: each element counts the data belonging to a time interval */
            const periodCountMss = [null, null, null, null, null, null, null, null, null, null];
            const periodCountMssAtt = [null, null, null, null, null, null, null, null, null, null];

            /* Count the manuscripts for the chart */
            for (const manuscript of this.mssList) {
                if (manuscript.__date) {
                    const msDate = manuscript.__date[DateCalendar.Islamic];
                    const isAttested = (manuscript.fkidms_types === 2);
                    const getNextCount = function(count) { return isNaN(count) ? 1 : count + 1; };

                    /* Determines which counter should be incremented */
                    if (msDate.from >= 401 && msDate.from <= 500) {
                        if (isAttested) {
                            periodCountMssAtt[0] = getNextCount(periodCountMssAtt[0]);
                        } else {
                            periodCountMss[0] = getNextCount(periodCountMss[0]);
                        }
                    } else if (msDate.from >= 501 && msDate.from <= 600) {
                        if (isAttested) {
                            periodCountMssAtt[1] = getNextCount(periodCountMssAtt[1]);
                        } else {
                            periodCountMss[1] = getNextCount(periodCountMss[1]);
                        }
                    } else if (msDate.from >= 601 && msDate.from <= 700) {
                        if (isAttested) {
                            periodCountMssAtt[2] = getNextCount(periodCountMssAtt[2]);
                        } else {
                            periodCountMss[2] = getNextCount(periodCountMss[2]);
                        }
                    } else if (msDate.from >= 701 && msDate.from <= 800) {
                        if (isAttested) {
                            periodCountMssAtt[3] = getNextCount(periodCountMssAtt[3]);
                        } else {
                            periodCountMss[3] = getNextCount(periodCountMss[3]);
                        }
                    } else if (msDate.from >= 801 && msDate.from <= 900) {
                        if (isAttested) {
                            periodCountMssAtt[4] = getNextCount(periodCountMssAtt[4]);
                        } else {
                            periodCountMss[4] = getNextCount(periodCountMss[4]);
                        }
                    } else if (msDate.from >= 901 && msDate.from <= 1000) {
                        if (isAttested) {
                            periodCountMssAtt[5] = getNextCount(periodCountMssAtt[5]);
                        } else {
                            periodCountMss[5] = getNextCount(periodCountMss[5]);
                        }
                    } else if (msDate.from >= 1001 && msDate.from <= 1100) {
                        if (isAttested) {
                            periodCountMssAtt[6] = getNextCount(periodCountMssAtt[6]);
                        } else {
                            periodCountMss[6] = getNextCount(periodCountMss[6]);
                        }
                    } else if (msDate.from >= 1101 && msDate.from <= 1200) {
                        if (isAttested) {
                            periodCountMssAtt[7] = getNextCount(periodCountMssAtt[7]);
                        } else {
                            periodCountMss[7] = getNextCount(periodCountMss[7]);
                        }
                    } else if (msDate.from >= 1201 && msDate.from <= 1300) {
                        if (isAttested) {
                            periodCountMssAtt[8] = getNextCount(periodCountMssAtt[8]);
                        } else {
                            periodCountMss[8] = getNextCount(periodCountMss[8]);
                        }
                    } else if (msDate.from >= 1301 && msDate.from <= 1400) {
                        if (isAttested) {
                            periodCountMssAtt[9] = getNextCount(periodCountMssAtt[9]);
                        } else {
                            periodCountMss[9] = getNextCount(periodCountMss[9]);
                        }
                    }
                }
            }

            /* Load chart data */
            const colStyle = 'opacity: 0.8';
            this.chartData = {
                chartType: 'ColumnChart',
                dataTable: [
                    ['Period', 'Mss preserved', { role: 'style' }, 'Mss attested', { role: 'style' }],
                    ['401 - 500H\n1001 - 1100', periodCountMss[0], colStyle, periodCountMssAtt[0], colStyle],
                    ['501 - 600H\n1101 - 1200', periodCountMss[1], colStyle, periodCountMssAtt[1], colStyle],
                    ['601 - 700H\n1201 - 1300', periodCountMss[2], colStyle, periodCountMssAtt[2], colStyle],
                    ['701 - 800H\n1301 - 1400', periodCountMss[3], colStyle, periodCountMssAtt[3], colStyle],
                    ['801 - 900H\n1401 - 1500', periodCountMss[4], colStyle, periodCountMssAtt[4], colStyle],
                    ['901 - 1000H\n1501 - 1600', periodCountMss[5], colStyle, periodCountMssAtt[5], colStyle],
                    ['1001 - 1100H\n1601 - 1700', periodCountMss[6], colStyle, periodCountMssAtt[6], colStyle],
                    ['1101 - 1200H\n1701 - 1800', periodCountMss[7], colStyle, periodCountMssAtt[7], colStyle],
                    ['1201 - 1300H\n1801 - 1900', periodCountMss[8], colStyle, periodCountMssAtt[8], colStyle],
                    ['1301 - 1400H\n1901 - 2000', periodCountMss[9], colStyle, periodCountMssAtt[9], colStyle]
                ],
                options: {
                    colors: ['#6c95a7', '#ba7c40'],
                    title: '',
                    titleTextStyle: {
                        fontSize: 32,
                        fontName: '"Open Sans", sans-serif',
                        bold: false,
                        color: '#784444'
                    },
                    height: 600,
                    hAxis: {
                        title: 'Time periods (from 401H/1001 to 1400H/2000)',
                        textStyle: {
                            fontSize: 14
                        }
                    },
                    vAxis: {
                        title: 'Number of manuscripts'
                    },
                    isStacked: true
                }
            };
        }
    }

    public chartSelect(event: ChartSelectEvent) {
        /* Navigate to manuscript list filtered by selected time period */
        if (event.selectedRowValues[0]) {
            const periodData = event.selectedRowValues[0].split(' - ');

            /* Update filters */
            this.mssListFilters.timePeriod = <DateRange> {
                from: parseInt(periodData[0], 10),
                to: parseInt(periodData[1], 10),
                calendar: DateCalendar.Islamic
            };
            this.manuscriptsService.updateFilters(this.mssListFilters);

            /* Navigate to manuscript list */
            this.router.navigate(['/manuscripts/list']);
        }
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ui/home-timechart/home-timechart.component.ts